import React, { useState, useEffect } from 'react';
import { supabase } from '../../lib/supabase';
import { Link } from 'react-router-dom';
import { Briefcase, Code, GraduationCap, Award, Languages, MessageSquare, ExternalLink } from 'lucide-react';

const AdminDashboard = () => {
  const [stats, setStats] = useState({});

  useEffect(() => {
    const fetchStats = async () => {
      const [exp, skills, edu, cert, lang, msgs] = await Promise.all([
        supabase.from('experiences').select('id', { count: 'exact', head: true }),
        supabase.from('skills').select('id', { count: 'exact', head: true }),
        supabase.from('education').select('id', { count: 'exact', head: true }),
        supabase.from('certifications').select('id', { count: 'exact', head: true }),
        supabase.from('languages_spoken').select('id', { count: 'exact', head: true }),
        supabase.from('contact_messages').select('id', { count: 'exact', head: true }).eq('is_read', false)
      ]);
      setStats({
        experiences: exp.count || 0, skills: skills.count || 0, education: edu.count || 0,
        certifications: cert.count || 0, languages: lang.count || 0, unreadMessages: msgs.count || 0
      });
    };
    fetchStats();
  }, []);

  const cards = [
    { label: 'Experiências', count: stats.experiences, icon: Briefcase, path: '/admin/experiences', color: 'lime' },
    { label: 'Skills', count: stats.skills, icon: Code, path: '/admin/skills', color: 'lime' },
    { label: 'Formação', count: stats.education, icon: GraduationCap, path: '/admin/education', color: 'lime' },
    { label: 'Certificações', count: stats.certifications, icon: Award, path: '/admin/certifications', color: 'lime' },
    { label: 'Idiomas', count: stats.languages, icon: Languages, path: '/admin/languages', color: 'lime' },
    { label: 'Mensagens não lidas', count: stats.unreadMessages, icon: MessageSquare, path: '/admin/messages', color: stats.unreadMessages > 0 ? 'red' : 'lime' },
  ];

  return (
    <div>
      <div className="flex items-center justify-between mb-8">
        <h1 className="text-2xl font-bold text-white">Dashboard</h1>
        <a href="/" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-2 text-lime-400 hover:text-lime-300 text-sm"><ExternalLink size={16} /><span>Ver Portfolio</span></a>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {cards.map(card => (
          <Link key={card.path} to={card.path} className="bg-gray-900 border border-gray-800 rounded-2xl p-6 hover:border-lime-400/30 transition-all group">
            <div className="flex items-center justify-between mb-4">
              <card.icon className={`${card.color === 'red' ? 'text-red-400' : 'text-lime-400'}`} size={28} />
              <span className={`text-3xl font-black ${card.color === 'red' ? 'text-red-400' : 'text-white'}`}>{card.count ?? '-'}</span>
            </div>
            <p className="text-gray-400 font-medium text-sm group-hover:text-white transition-colors">{card.label}</p>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default AdminDashboard;
